<div class="header">
  <span class="title">My Preferences</span>
</div>

<form [formGroup]="dashPreferencesForm" class="t-section">
  <div class="t-section-header">
    <div class="t-section-title">Select your <a class="t-link" [href]="homeTabUrl">Home</a> tab tiles (drag and drop to
      reorder)</div>
  </div>
  <div cdkDropList class="t-section-body" (cdkDropListDropped)="onReorder($event)">
    <div cdkDrag *ngFor="let tile of userSelectableTiles" class="mb-1">
      <kendo-switch [onLabel]="'On'" [formControlName]="tile.type" [offLabel]="'Off'" class="t-custom-switch"
        (click)=onTileSelectChange()>
      </kendo-switch>
      {{tile.title}}
    </div>
  </div>
</form>
<app-key-team-members></app-key-team-members>
